module.exports = __webpack_public_path__ + "static/media/img_Inscription_syuku.af655833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_syuku.png
// module id = 976
// module chunks = 0